<template>
  <div>
    <nav class="breadcrumb" aria-label="breadcrumbs">
      <ul>
        <li>
          <nuxt-link :to="localePath('office-products')">
            {{ $t("page.products") }}
          </nuxt-link>
        </li>
        <li>
          <nuxt-link :to="localePath('office-products-metal')">
            {{ $t("page.metal") }}
          </nuxt-link>
        </li>
        <li>
          <nuxt-link :to="localePath('office-products-metal-metal-posts')">
            {{ $t("page.metal_posts") }}
          </nuxt-link>
        </li>

        <li class="is-active">
          <a aria-current="page">{{ active.id }} ({{ active.name }})</a>
        </li>
      </ul>
    </nav>

    <div class="columns">
      <div class="column is-narrow">
        <div class="box" style="margin: 0 auto 30px; min-width: 300px">
          <figure class="image is-5by3" v-if="active.image">
            <img
              :src="active.image"
              style="object-fit: contain; object-position: center"
            />
          </figure>
          <table
            class="table is-striped is-fullwidth"
            ref="table"
            :class="{ 'm-t-5': active.image }"
            v-if="$store.getters['options/edge_processing'].length"
          >
            <tr>
              <th>{{ $t("form.name") }}</th>
              <td>{{ active.name }}</td>
            </tr>

            <tr>
              <th>{{ $t("form.industry") }}</th>
              <td>
                <nuxt-link
                  :to="
                    localePath({
                      name: 'office-industries-id',
                      params: { id: active.industry_id },
                    })
                  "
                  >{{ active.industry_name }}</nuxt-link
                >
              </td>
            </tr>
            <tr>
              <th>{{ $t("form.delivery_time") }}</th>
              <td>
                <i class="mdi mdi-clock-outline"></i>
                &nbsp;{{ active.delivery_time }}
              </td>
            </tr>
            <tr>
              <th>{{ $t("form.product_class") }}</th>

              <td>
                <i class="mdi mdi-octagram-outline"></i>
                &nbsp;{{ active.product_class }}
              </td>
            </tr>
            <tr>
              <th>{{ $t("form.ep_required") }}</th>
              <td>
                <span v-if="active.ep_required">
                  <i class="mdi mdi-check-all"></i>
                  &nbsp;{{ $t("form.yes") }}
                </span>
                <span v-else>
                  <i class="mdi mdi-close"></i>
                  &nbsp;{{ $t("form.no") }}
                </span>
              </td>
            </tr>
            <tr>
              <th>{{ $t("form.available") }}</th>
              <td>
                <span v-if="active.available">
                  <i class="mdi mdi-check-all"></i>
                  &nbsp;{{ $t("form.yes") }}
                </span>
                <span v-else>
                  <i class="mdi mdi-close"></i>
                  &nbsp;{{ $t("form.no") }}
                </span>
              </td>
            </tr>
          </table>
        </div>
        <div class="field m-t-5">
          <div class="control is-clearfix">
            <nuxt-link
              :to="
                localePath({
                  name: 'office-products-metal-metal-posts-edit-id',
                  params: { id: active.id },
                })
              "
              class="button is-link is-small m-r-2"
            >
              <i class="mdi mdi-pencil"></i>
            </nuxt-link>
            <button
              @click="removeItem"
              class="button is-small is-danger"
              :class="{ 'is-loading': removeLoading }"
            >
              <i class="mdi mdi-trash-can-outline"></i>
            </button>
            <button
              class="button is-small is-success is-pulled-right"
              :class="{ 'is-loading': isDuplicating }"
              @click="duplicate"
            >
              <i class="mdi mdi-content-copy"></i>
            </button>
            <!-- <button
              class="button is-small is-info is-pulled-right m-r-2"
              @click="downloadFile(`/metal/export/metalPosts/${active.id}`)"
            >
              <i class="mdi mdi-database-export"></i>
            </button> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  async asyncData({ store, params, error, query }) {
    try {
      await store.dispatch("metal/setMetalPostsActive", params.id);
    } catch (e) {
      error(e);
    }
  },

  data() {
    return {
      removeLoading: false,
      isDuplicating: false,
    };
  },

  computed: {
    active() {
      return this.$store.state.metal.metalPostsActive;
    },
  },

  methods: {
    async removeItem() {
      if (confirm(this.$t("message.are_you_sure"))) {
        this.removeLoading = true;

        try {
          await this.$api.deleteMetalPost(this.$route.params.id);
          this.$router.replace(
            this.localePath("office-products-metal-metal-posts")
          );
        } catch (e) {
          this.handleFormError(e.response.data);
        }

        this.removeLoading = false;
      }
    },

    async duplicate() {
      if (confirm(this.$t("message.are_you_sure"))) {
        this.isDuplicating = true;

        try {
          const { data } = await this.$api.duplicateMetalPost({
            id: this.$route.params.id,
          });
          this.$router.replace(
            this.localePath({
              name: "office-products-metal-metal-posts-edit-id",
              params: { id: data.id },
            })
          );
        } catch (e) {
          this.handleFormError(e.response.data);
        }

        this.isDuplicating = false;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.variant-link {
  display: flex;
  padding: 5px 15px;

  span:last-child {
    margin-left: auto;
    text-align: right;
  }
}
</style>



// WEBPACK FOOTER //
// resources/nuxt/pages/office/products/metal/metal-posts/_id/index.vue